export default {
  name: 'ViewIntegration',
  props: ['id'],
  data: function data() {
    return {
      integration: false,
      html_info: '',
      fetching: false,
      other_data: false,
      fetch_counter: 0
    };
  },
  methods: {
    fetchIntegration: function fetchIntegration() {
      var _this = this;
      this.fetching = true;
      this.fetch_counter += 1;
      this.$get('integrations/' + this.id).then(function (response) {
        _this.integration = response.integration;
        _this.html_info = response.html_info;
        _this.other_data = response.other_data;
      })["catch"](function (errors) {
        _this.$handleError(errors);
      }).always(function () {
        _this.fetching = false;
      });
    },
    publish: function publish() {
      var _this2 = this;
      this.fetching = true;
      this.$put('integrations/' + this.id, {
        status: 'published'
      }).then(function (response) {
        _this2.integration = response.integration;
        _this2.html_info = response.html_info;
        _this2.other_data = response.other_data;
      })["catch"](function (errors) {
        _this2.$handleError(errors);
      }).always(function () {
        _this2.fetching = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetchIntegration();
  }
};